export const SET_APPLIED_FOR_VERIFICATION = 'SET_APPLIED_FOR_VERIFICATION'
export const SET_VERIFICATION_APPLIED = 'SET_VERIFICATION_APPLIED'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_ADMIN = 'SET_ADMIN'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'
export const RESET_ERROR = 'RESET_ERROR'
